class NiuNiuGallery extends HTMLElement {
  connectedCallback() {
    if(this.ready)return;this.ready=true;
    const section=this.closest('product-info');
    this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{if(data.sectionId!==section?.dataset.section)return;const gallery=data.html.querySelector('nn-gallery');if(gallery)this.innerHTML=gallery.innerHTML;});
    this.addEventListener('click',e=>{const button=e.target.closest('[data-gallery-index]');if(button){this.querySelectorAll('[data-gallery-slide]').forEach(x=>x.hidden=x.dataset.gallerySlide!==button.dataset.galleryIndex);this.querySelectorAll('[data-gallery-index]').forEach(x=>x.setAttribute('aria-pressed',String(x===button)));}if(e.target.closest('[data-zoom]')){const source=this.querySelector('[data-gallery-slide]:not([hidden]) img');const dialog=this.querySelector('dialog');if(source&&dialog){const image=dialog.querySelector('img');image.src=source.currentSrc;image.alt=source.alt;dialog.showModal();}}});
  }
  disconnectedCallback(){this.unsubscribe?.();this.ready=false;}
}
class NiuNiuPacks extends HTMLElement {
  connectedCallback(){if(this.ready)return;this.ready=true;const qty=this.closest('product-info')?.querySelector('input[name="quantity"]');if(!qty)return;const sync=()=>{this.quantity=qty.value;this.querySelectorAll('button').forEach(x=>x.setAttribute('aria-pressed',String(x.dataset.quantity===qty.value)));};qty.addEventListener('change',sync);qty.addEventListener('input',sync);this.addEventListener('click',e=>{const b=e.target.closest('[data-quantity]');if(!b)return;qty.value=b.dataset.quantity;qty.dispatchEvent(new Event('change',{bubbles:true}));});
    this.unsubscribe=subscribe(PUB_SUB_EVENTS.variantChange,({data})=>{if(data.sectionId!==this.closest('product-info')?.dataset.section)return;const packs=data.html.querySelector('nn-packs');if(packs){this.innerHTML=packs.innerHTML;qty.value=this.quantity;if(!qty.checkValidity())qty.value=qty.min||'1';qty.dispatchEvent(new Event('change',{bubbles:true}));}});sync();}
  disconnectedCallback(){this.unsubscribe?.();this.ready=false;}
}
class NiuNiuRail extends HTMLElement {
  connectedCallback(){if(this.ready)return;this.ready=true;const track=this.querySelector('.nn-rail-track');this.addEventListener('click',e=>{const b=e.target.closest('[data-direction]');if(b)track.scrollBy({left:track.clientWidth*Number(b.dataset.direction),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
    const slider=this.querySelector('.nn-video-scroll');
    if(slider){
      this.scrollAbort=new AbortController();
      this.setAttribute('data-scrollbar','');
      const sync=()=>{
        const max=track.scrollWidth-track.clientWidth;
        slider.hidden=max<=1;
        slider.value=max>0?Math.max(0,Math.min(100,track.scrollLeft/max*100)):0;
        slider.style.setProperty('--thumb-width',`${Math.max(32,track.clientWidth*track.clientWidth/(track.scrollWidth||1))}px`);
      };
      slider.addEventListener('input',()=>track.scrollTo({left:(track.scrollWidth-track.clientWidth)*Number(slider.value)/100,behavior:'instant'}),{signal:this.scrollAbort.signal});
      track.addEventListener('scroll',sync,{passive:true,signal:this.scrollAbort.signal});
      this.resizeObserver=new ResizeObserver(()=>{sync();this.syncMotion?.();});this.resizeObserver.observe(track);sync();
      if(this.dataset.autoScroll==='true')this.setupAutoScroll(track,slider);
    }
    if(this.dataset.autoplay!=='true'||matchMedia('(prefers-reduced-motion: reduce)').matches)return;
    const videos=[...this.querySelectorAll('video')];this.visible=new Set();this.manual=new WeakSet();this.autoPausing=new WeakSet();
    this.observer=new IntersectionObserver(entries=>entries.forEach(({target:v,isIntersecting,intersectionRatio})=>{if(isIntersecting&&intersectionRatio>=.6){this.visible.add(v);if(!this.manual.has(v)&&!document.hidden){v.muted=true;v.play().catch(()=>{});}}else{this.visible.delete(v);if(!v.paused){this.autoPausing.add(v);v.pause();}}}),{threshold:[0,.6]});
    videos.forEach(v=>{v.addEventListener('pause',()=>{if(this.autoPausing.has(v)){this.autoPausing.delete(v);}else this.manual.add(v);});v.addEventListener('play',()=>this.manual.delete(v));this.observer.observe(v);});
    this.visibility=()=>this.visible.forEach(v=>{if(document.hidden&&!v.paused){this.autoPausing.add(v);v.pause();}else if(!document.hidden&&!this.manual.has(v))v.play().catch(()=>{});});document.addEventListener('visibilitychange',this.visibility);
  }
  setupAutoScroll(track,slider){
    const button=this.querySelector('[data-rail-motion]');
    const motion=matchMedia('(prefers-reduced-motion: reduce)');
    const options={signal:this.scrollAbort.signal};
    let paused=false,hover=false,inView=false;
    this.syncMotion=()=>{
      cancelAnimationFrame(this.autoFrame);
      const max=track.scrollWidth-track.clientWidth;
      button.hidden=max<=1||motion.matches;
      button.setAttribute('aria-pressed',String(!paused));
      button.setAttribute('aria-label',paused?(track.scrollLeft>=max-1?window.nnUi.replay_scroll:window.nnUi.start_scroll):window.nnUi.pause_scroll);
      button.querySelector('span').textContent=paused?'▷':'Ⅱ';
      if(paused||hover||!inView||document.hidden||motion.matches||max<=1)return;
      let previous=null,position=track.scrollLeft;
      const step=now=>{
        if(previous!==null){position=Math.min(max,position+Math.min(now-previous,100)*.008);track.scrollTo({left:position,behavior:'instant'});}
        previous=now;
        if(position>=max){paused=true;this.syncMotion();}else this.autoFrame=requestAnimationFrame(step);
      };
      this.autoFrame=requestAnimationFrame(step);
    };
    const stop=()=>{paused=true;this.syncMotion();};
    for(const event of ['pointerdown','wheel','keydown','focusin'])track.addEventListener(event,stop,options);
    slider.addEventListener('input',stop,options);slider.addEventListener('focus',stop,options);
    track.addEventListener('pointerenter',()=>{hover=true;this.syncMotion();},options);
    track.addEventListener('pointerleave',()=>{hover=false;this.syncMotion();},options);
    button.addEventListener('click',()=>{if(paused&&track.scrollLeft>=track.scrollWidth-track.clientWidth-1)track.scrollTo({left:0,behavior:'instant'});paused=!paused;this.syncMotion();},options);
    document.addEventListener('visibilitychange',this.syncMotion,options);motion.addEventListener('change',this.syncMotion,options);
    this.autoObserver=new IntersectionObserver(entries=>{inView=entries[0].isIntersecting&&entries[0].intersectionRatio>=.35;this.syncMotion();},{threshold:[0,.35]});
    this.autoObserver.observe(this);this.syncMotion();
  }
  disconnectedCallback(){this.observer?.disconnect();this.resizeObserver?.disconnect();this.autoObserver?.disconnect();cancelAnimationFrame(this.autoFrame);this.scrollAbort?.abort();this.syncMotion=null;if(this.visibility)document.removeEventListener('visibilitychange',this.visibility);this.ready=false;}
}
if(!customElements.get('nn-gallery'))customElements.define('nn-gallery',NiuNiuGallery);
if(!customElements.get('nn-packs'))customElements.define('nn-packs',NiuNiuPacks);
if(!customElements.get('nn-rail'))customElements.define('nn-rail',NiuNiuRail);

class NiuNiuStickyBuy extends HTMLElement {
  connectedCallback() {
    if (this.ready) return;
    this.section = this.closest('product-info');
    this.main = this.section?.querySelector('product-form button[type="submit"]');
    if (!this.main) return;
    this.ready = true;
    this.button = this.querySelector('button');
    this.abort = new AbortController();
    this.sync = () => this.updateSummary();
    this.section.addEventListener('change', this.sync, {signal:this.abort.signal});
    this.mutation = new MutationObserver(this.sync);
    this.mutation.observe(this.main, {attributes:true, attributeFilter:['disabled','aria-disabled','class'], childList:true, characterData:true, subtree:true});
    this.updateVisibility = () => { this.hidden = this.main.getBoundingClientRect().bottom >= 0; };
    this.onScroll = () => {
      if (this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => { this.scrollFrame = null; this.updateVisibility(); });
    };
    window.addEventListener('scroll', this.onScroll, {passive:true, signal:this.abort.signal});
    window.addEventListener('resize', this.onScroll, {signal:this.abort.signal});
    this.updateVisibility();
    this.button.addEventListener('click', () => {
      if (!this.button.disabled) this.main.click();
    }, {signal:this.abort.signal});
    this.updateSummary();
  }
  updateSummary() {
    this.button.disabled = this.main.disabled || this.main.getAttribute('aria-disabled') === 'true';
    this.button.setAttribute('aria-busy', String(this.main.classList.contains('loading')));
    this.button.querySelector('span').textContent = this.main.querySelector('span')?.textContent.trim() || this.main.textContent.trim();
    const offer = this.section.querySelector('nn-lounger-offer');
    if (!offer?.ready) return;
    const variant = offer.selectedVariant();
    const models = (offer.mode === 'duo' ? offer.models : offer.models.slice(0,1)).map(id => offer.singles.find(v => v.id === id));
    this.querySelector('[data-sticky-design]').textContent = models.map(v => v.title).join(' + ');
    this.querySelector('[data-sticky-price]').textContent = variant?.money || '—';
    this.querySelectorAll('.nn-sticky-image').forEach((img,i) => {
      const model = models[i];
      img.hidden = !model?.image;
      if (!model?.image) return;
      const url = new URL(model.image, location.origin);
      url.searchParams.set('width','144');
      img.removeAttribute('srcset');
      if (img.getAttribute('src') !== url.href) img.src = url.href;
      img.alt = model.title;
    });
    this.querySelector('.nn-sticky-images')?.classList.toggle('is-duo', models.length === 2);
  }
  disconnectedCallback() {
    cancelAnimationFrame(this.scrollFrame);
    this.scrollFrame = null;
    this.mutation?.disconnect();
    this.abort?.abort();
    this.ready = false;
  }
}
if(!customElements.get('nn-sticky-buy'))customElements.define('nn-sticky-buy',NiuNiuStickyBuy);
